import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Flame, X } from 'lucide-react';
import { useUrgencyBanner } from '@/store/dataStore';

export default function UrgencyBanner() {
  const { urgency } = useUrgencyBanner();
  const [closed, setClosed] = useState(false);
  if (!urgency?.enabled || closed) return null;
  return (
    <div className="relative overflow-hidden" style={{ backgroundColor: urgency.bg, color: urgency.textColor }}>
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center gap-3 text-sm font-semibold">
        <Flame size={16} className="flex-shrink-0 animate-pulse" />
        <div className="flex-1 truncate">{urgency.message}</div>
        {urgency.href && urgency.cta && (
          <Link to={urgency.href} className="hidden sm:inline-block px-3 py-1 rounded-full text-xs font-bold flex-shrink-0" style={{ backgroundColor: urgency.textColor, color: urgency.bg }}>{urgency.cta}</Link>
        )}
        <button onClick={() => setClosed(true)} className="flex-shrink-0 opacity-70 hover:opacity-100"><X size={16} /></button>
      </div>
    </div>
  );
}
